<!--
// nuxt-ui/components/pages/region-matches-match-homeTeam-vs-awayTeam/MatchEventsBreakEvent.vue
-->
<script setup lang="ts"></script>

<template>
  <div class="events-event-break align-center">
    <div>HT</div>
    <div class="events-event-break-bar"></div>
    <div>HT</div>
  </div>
</template>

<style scoped>
.events-event-break {
  @apply flex md:flex-col items-center justify-center md:justify-start md:items-start text-center gap-1 text-xs text-gray-400;
}

.events-event-break-bar {
  @apply w-3 h-[1px] md:h-3 md:w-[1px] bg-gray-400 md:mx-auto;
}
</style>
